























import Vue from 'vue'
import { downloadFile } from '@/utils'
import {debounce} from '@/utils/comment.js'

export default Vue.extend({
  name: 'ImportButton',
  props: [
    'filename',
    'downloadFn',
    'importFn',
    'type',
    'productId',
    'customParams',
    'refresh',
    'newResFlag',
    'areaId',
    'typeX'
  ],
  data() {
    return {
      visible: false,
      loading: {
        submit: false,
        download: false
      },
      fileList: []
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (!val) {
          this.fileList = []
        }
      }
    }
  },
  methods: {
    
    openModal() {
      this.visible = true
    },
    async download() {
      this.loading.download = true
      try {
        console.log(this.areaId)
        if(this.areaId != '') {
          let res = await this.downloadFn(this.areaId == '0' ? '' :this.areaId)
          downloadFile(res, this.filename)
        }
        else {
          let res = await this.downloadFn()
          downloadFile(res, this.filename)
        }
        
      } finally {
        this.loading.download = false
      }
    },
    submitX: debounce(function(){
    		this.submit()
   	},1000),
    async submit() {

      const [file] = this.fileList
      this.loading.submit = true
      let idX = this.areaId;
      console.log(idX,'aaaaaaaaaaaa')
      // return;
      if(this.areaId == 0) {
        idX = ''
      }
      else if(this.areaId === '') {
        idX = ''
      }
      console.log(idX,'bbbbbbbbbbbb')
          
      try {
        const formData = new FormData()
        formData.append('file', file, file.name)
        if(this.typeX == 'location') {
          formData.append('areaId', idX)
        }  
        else {

        }
        let res
        if (this.type && this.type === 'wrangDown') {
          
          console.log('this3')  
          res = await this.importFn(formData)
          if (res.type === 'application/json') {
            this.$emit('refresh')
            this.refresh()
          } else {
            downloadFile(res, 'errorMsg.xlsx')
          }
        } else if (this.type && this.type === 'process') {
          formData.append('productId', this.productId)
          
          res = await this.importFn(formData)
          this.$message.info(this.$t(res.data.data.importResult))
          if (res.data.data.failInfo) {
            // 失败提示
            this.$message.info(this.$t(res.data.data.failInfo))
          } else {
            // 成功则刷新工艺版本
            this.$emit('refresh')
          }
        } else {
          if (this.customParams) {
            // 自定义导入参数
            console.log('this1')
            res = await this.importFn(file)
          } else {
            console.log('this2')
            res = await this.importFn(formData)
          }
          if (this.newResFlag) {
            // 新返回形式：无论导入成功与否都返回文件流
            const reader = new FileReader()
            reader.readAsText(res)
            reader.onload = () => {
              if (reader.result && res.type === 'application/vnd.ms-excel') {
                // 导入发生错误,下载错误提示文件
                this.$message.info(this.$t('import_err_tip'))
                downloadFile(res, 'errorMsg.xlsx')
              } else {
                // 导入成功
                if (this.refresh) {
                  this.refresh()
                }
                this.$emit('refresh')
                this.$message.info(this.$t('page_workstation_maintain_inport_success'))
              }
            }
          } else {
            // 旧返回形式：返回成功数，错误数
            if (this.refresh) {
              this.refresh()
            }
            this.$emit('refresh')
            if(res && res.data && res.data.data){
              this.$message.info(
              this.$t('page_upload_info')
                .replace('{0}', res.data.data.uploadTotal)
                .replace('{1}', res.data.data.successUploadRecords)
                .replace('{2}', res.data.data.failUploadRecords)
              )
            }else{
               this.$message.success(this.$t('page_workstation_maintain_inport_success'))
            }
            
          }
        }

        this.visible = false
      } finally {
        this.loading.submit = false
      }
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file]
      return false
    }
  }
})
